import React from 'react';
import { ButtonV3 } from '../ButtonV3';
import FeaturedImage, { FeaturedImageProps } from './FeaturedImage';
import {
  GridItemWrapper,
  GridTextWrapper,
  GridWrapper,
  HoverDek,
  HoverWrapper,
} from './Grid.styles';
import HighlightTitle, { HighlightTitleProps } from './HighlightTitle';
import { mobileOnly, excludeMobile } from '../../styles/emotion/mixins/responsive';

export type GridImageItem = {
  image: FeaturedImageProps;
  hoverState?: {
    hed: HighlightTitleProps;
    dek?: string;
    href: string;
    linkText: string;
  };
};

export type GridTextItem = {
  highlightTitle: HighlightTitleProps;
  href: string;
  linkText: string;
};

export type GridProps = {
  /* grid items to be displayed on desktop, typically will be 9 items */
  desktopGridItems: (GridImageItem | GridTextItem)[];
  /* grid items to be displayed on mobile and tablet, typically will be 6 items */
  mobileGridItems: (GridImageItem | GridTextItem)[];
  /** @deprecated This prop is no longer used within this component and is safe to remove and */
  isMobile?: false;
};

const Grid: React.FC<GridProps> = (props): JSX.Element => {
  const { desktopGridItems, mobileGridItems } = props;

  const renderGridItem = (item: GridImageItem | GridTextItem, i: number) => {
    if ('highlightTitle' in item) {
      const { highlightTitle, href, linkText } = item;
      const { highlightText, titleStart, titleEnd } = highlightTitle;
      return (
        <GridTextWrapper key={i}>
          <HighlightTitle
            highlightText={highlightText}
            titleEnd={titleEnd}
            titleStart={titleStart}
            isH1={false}
          />
          <ButtonV3 component="a" href={href}>
            {linkText}
          </ButtonV3>
        </GridTextWrapper>
      );
    }

    const { image, hoverState } = item;
    const { hed, dek, href, linkText } = hoverState || {};
    return (
      <GridItemWrapper hasHoverState={!!hoverState} key={i}>
        <FeaturedImage {...image} />
        {hoverState && (
          <HoverWrapper>
            {hed && (
              <HighlightTitle
                highlightText={hed.highlightText}
                titleEnd={hed.titleEnd}
                titleStart={hed.titleStart}
                isH1={false}
              />
            )}

            {dek && <HoverDek>{dek}</HoverDek>}
            <ButtonV3 component="a" href={href} variant="secondary">
              {linkText}
            </ButtonV3>
          </HoverWrapper>
        )}
      </GridItemWrapper>
    );
  };

  return (
    <>
      <GridWrapper css={mobileOnly}>{mobileGridItems.map(renderGridItem)}</GridWrapper>
      <GridWrapper css={excludeMobile}>{desktopGridItems.map(renderGridItem)}</GridWrapper>
    </>
  );
};

export default Grid;
